.container {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 4px 8px;
}

.item {
  display: contents;
  font-size: var(--sm-font-size);
}

.label {
  color: var(--neutral-7-color);
  white-space: nowrap;
}
